module.exports = __webpack_public_path__ + "static/media/confirm-checkbox-normal.d8128cb7.svg";